import { render, staticRenderFns } from "./zy_jl.vue?vue&type=template&id=fcf20c3e&scoped=true"
import script from "./zy_jl.vue?vue&type=script&lang=js"
export * from "./zy_jl.vue?vue&type=script&lang=js"
import style0 from "./zy_jl.vue?vue&type=style&index=0&id=fcf20c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf20c3e",
  null
  
)

export default component.exports